import React, { useState } from 'react'; 
import Popup from '../components/CusPopup';
import { Checkbox } from '@progress/kendo-react-inputs';
import eData from '../hybriddata/popupdata.json';
import { Button } from '@progress/kendo-react-buttons';
import { SingleFormLabel, SingleFormLabelBold } from '../validation/Form-Components';
import { MdClose } from "react-icons/md";
import styled from "styled-components";

const CloseModalButton = styled(MdClose)`
color: white;
cursor: pointer;
position: absolute;
top: 10px;
right: 10px;
width: 32px;
height: 32px;
`;
const BTLDisclaimerPopup = (props) => {

    return props.popupValue &&(
        <div className="popup">
        <div className="popup-inner">
            <CloseModalButton
                aria-label="Close modal"
                onClick={() =>{
                    props.setPopupValue(false);
                    props.OnCloseClick();
                } }
            />
            <div className='fbaPSize'>
                <div className="bgBlackYellowBorder">
                    <div className="row">
                        <div className="col-10">
                            <div className="dcPgmh">{eData.btlDeclare.header}</div>
                        </div>
                    </div>
                </div><br/>
            </div>
            <div className='fbaPSize'>
                <p className="ft-p-txt">{eData.btlDeclare.sub}</p>
                {/* <p className="ft-p-txt-b">{eData.btlDeclare.title}</p> */}
          
                {eData.btlDeclare.declareList.map((item, idx) => (
                <div key={idx}>
                    <div style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap', paddingBottom: '10px'}}>
                        <ol style={{ listStyle: "disc", marginBottom: "0"}}>
                            <li>{item.lblname}</li>
                        </ol>
                    </div>
                </div>
                ))}
            </div>
            <br/>
            <div className="row">
                <div className="col-12" style={{ textAlign: "center" }}>
                    <Button primary={true} className="k-button btn btn-success"
                        disabled={false} onClick={props.onClickProceed}>{eData.btlDeclare.btProceed}</Button>
                </div>
            </div>
            <br/>
        </div>
    </div>
    )
}

export default BTLDisclaimerPopup